'use strict';
export var AssistantEnvironment;
(function (AssistantEnvironment) {
    AssistantEnvironment["Tiger"] = "TIGER";
    AssistantEnvironment["Barracuda"] = "BARRACUDA";
    AssistantEnvironment["Orca"] = "ORCA";
    AssistantEnvironment["QA10"] = "QA10";
})(AssistantEnvironment || (AssistantEnvironment = {}));
